export const DEFAULT_LEAD_CARD_FIELDS: string[] = ['value', 'owner', 'accounts', 'contacts'];
export const DEFAULT_LEAD_CARD_FIELDS_WITH_NUMBER: string[] = [
    'number',
    ...DEFAULT_LEAD_CARD_FIELDS,
];
